import axios from 'axios'

// Create axios instance
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL
})

// Add request interceptor to automatically include auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Add response interceptor to handle common errors
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('access_token')
      window.location.href = '/login'
    }
    // AI credit exhaustion: broadcast so a single app-level modal can
    // prompt the user to upgrade, without every call site handling it.
    const data = error.response?.data
    if (error.response?.status === 402 && data?.error === 'LIMIT_EXCEEDED' && data?.resource === 'ai_credits') {
      window.dispatchEvent(new CustomEvent('ai-credits-exceeded', { detail: data }))
    }
    return Promise.reject(error)
  }
)

export default axiosInstance
